import {computed, makeObservable} from "mobx";
import SaporeForm from "../SaporeForm";
import TextField from "./TextField";

export default class DeliverySiteForm extends SaporeForm {
    static newFor(deliverySite, feature) {
        return new DeliverySiteForm(deliverySite, feature);
    }

    constructor(initialData = {}, feature) {
        const fields = {
            name: new TextField(0, 200, true, initialData.name || '', feature),
            address: new TextField(0, 200, true, initialData.address || '', feature),
            city: new TextField(0, 200, true, initialData.city || '', feature),
            jurisdiction: new TextField(0, 200, true, initialData.jurisdiction || '', feature),
            postalCode: new TextField(0, 200, true, initialData.postalCode || '', feature),
        };
        super(fields, null, feature, undefined);
        makeObservable(this, {
            nameValue: computed,
            addressValue: computed,
            cityValue: computed,
        });
    }

    name() {
        return this.nameField().value;
    }

    address() {
        return this.addressField().value;
    }

    city() {
        return this.cityField().value;
    }

    nameField() {
        return this.getFieldByName('name');
    }

    addressField() {
        return this.getFieldByName('address');
    }

    cityField() {
        return this.getFieldByName('city');
    }

    get nameValue() {
        return this.name();
    }

    get addressValue() {
        return this.address();
    }

    get cityValue() {
        return this.city();
    }

    async updateMultipleFieldsWithValues(fieldUpdates) {
        Object.entries(fieldUpdates).forEach(([fieldName, value]) => {
            if (value !== undefined && value !== null) {
                this.getFieldByName(fieldName)?.updateValue(value);
            }
        });
    }

    isReadonly(_fieldName) {
        return true;
    }
}
